"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationFullSpecs = void 0;
var _reactRedux = require("react-redux");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var useRecommendationFullSpecs = function useRecommendationFullSpecs() {
  var _useSelector, _useSelector$selected;
  var fullSpecs = (_useSelector = (0, _reactRedux.useSelector)(_recommendationSelectors.selectSelectedHandset)) === null || _useSelector === void 0 ? void 0 : (_useSelector$selected = _useSelector.selectedVariant) === null || _useSelector$selected === void 0 ? void 0 : _useSelector$selected.groupedCharacteristics;
  return {
    groupedSpecs: fullSpecs
  };
};
exports.useRecommendationFullSpecs = useRecommendationFullSpecs;